<form #form="ngForm" class="campanha-vigencia-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Vigência
            </h6>
            <p class="form-text text-muted">
                Dados da vigência desta campanha
            </p>
        </div>  

        <div class="card-body">
            <!-- Sob Demanda -->
            <div class="row">
                <div class="form-group col-12">
                    <sgt-sob-demanda-form-control-radio
                        [sobDemanda]="sobDemanda"
                        [canEdit]="false"
                        [required]="true"
                        inputLabel="Este campanha é sob demanda?"
                        inputHelpText="Uma campanha sob demanda não possui uma vigência determinada e é solicitada conforme sua necessidade de uso"
                        msgRequiredError="É obrigatório informar se este pacote é sob demanda ou não">
                    </sgt-sob-demanda-form-control-radio>
                </div>
            </div>  

            <ng-template [ngIf]="!sobDemanda">
                <div class="row">
                    <div class="form-group col-12">
                        <sgt-vigencia-campanha-form-control-radio
                            [(vigenciaRecorrente)]="entity.vigenciaRecorrente"
                            [required]="true"
                            [canEdit]="canEdit && canEditVigenciaRecorrente"
                            inputLabel="Esta campanha é recorrente?"
                            msgRequiredError="É obrigatório selecionar se a vigência desta campanha é recorrente ou não"
                            inputHelpText="Uma campanha recorrente é aquela que não possui uma data de término definida e que ocorre repetidamente sem prazo de vigência determinado"
                            name="vigenciaRecorrente"
                            id="vigenciaRecorrente">
                        </sgt-vigencia-campanha-form-control-radio>         
                    </div>
                </div>
    
                <div class="row" *ngIf="!entity.vigenciaRecorrente">
                    <div class="form-group col-12 col-xl-3">
                        <label for="instrucao" class="col-form-label">Quantidade Dias Vigência</label>
                        <div class="input-group">
                            <input type="number" class="form-control text-right" [(ngModel)]="entity.quantidadeDiasVigencia" name="quantidadeDiasVigencia" id="quantidadeDiasVigencia"
                                #quantidadeDiasVigencia="ngModel" #quantidadeDiasVigenciaInput required="required" [disabled]="!canEdit || !canEditQuantidadeDiasVigencia" [readonly]="!canEdit || !canEditQuantidadeDiasVigencia">
                            <div class="input-group-append">
                                <span class="input-group-text">
                                    Dia(s)
                                </span>
                            </div>
                        </div>
                        <p class="form-text">
                            Quantidade de dias que esta campanha vigorará após o início
                        </p>                               
                        <sgt-form-control-error
                            *ngIf="quantidadeDiasVigencia.errors && quantidadeDiasVigencia.errors.required && quantidadeDiasVigencia.dirty"
                            msgError="A quantidade de dias obrigatória">
                        </sgt-form-control-error>                            
                    </div>
                </div>            
            </ng-template>

            <div class="row">
                <div class="form-group col-12 col-md-4" *ngIf="entity.dataInicioAndamento">
                    <label for="dataInicioAndamento" class="col-form-label">Data de Início</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="far fa-calendar"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control text-center" [value]="entity.dataInicioAndamento | date: 'dd/MM/yyyy HH:mm'" disabled="disabled" readonly="readonly"> 
                    </div>
                    <p class="form-text">Data de início da campanha</p>
                </div>
                
                <div class="form-group col-12 col-md-4" *ngIf="!entity.dataTerminoAndamento && entity.dataTerminoVigencia">
                    <label for="dataTerminoVigencia" class="col-form-label">Data de Término Prevista</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fas fa-flag-checkered"></i>
                            </span>
                        </div>                    
                        <input type="text" class="form-control text-center" [value]="entity.dataTerminoVigencia | date: 'dd/MM/yyyy'" disabled="disabled" readonly="readonly"> 
                    </div>
                    <p class="form-text">Data prevista para o término da campanha</p>
                </div> 

                <div class="form-group col-12 col-md-4" *ngIf="entity.dataTerminoAndamento">
                    <label for="dataTerminoAndamento" class="col-form-label">Data de Término</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="far fa-calendar-check"></i>
                            </span>
                        </div> 
                        <input type="text" class="form-control text-center" [value]="entity.dataTerminoAndamento | date: 'dd/MM/yyyy HH:mm'" disabled="disabled" readonly="readonly"> 
                    </div>                    
                    <p class="form-text">Data de término da campanha</p>
                </div>                                    
            </div>            
        </div>
    </div>

</form>